import { useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { ContentGroups, TranslationNamespaces } from '~/lib/constants';
import { Tagged } from '~/apps/smartsend/components/Tagged';
import { ContentContext, useAnalytics } from '@parcel2go/npm-p2g-app';
import { Suspense, useCallback, useContext } from 'react';
import useLocalStorage from '~/hooks/use-local-storage';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import SmartSendSetupProcess from '~/apps/smartsend/components/onboarding';
import SearchInitialiser from '../layouts/my-account/search-initialiser';
import RequireCustomer from '../layouts/my-account/require-customer';
import { LocalStorageKeys } from '~/apps/smartsend/lib/consts/LocalStorageKeys';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import { NavigationContext } from '~/components/nav/nav-context';
import useOnLoad from '../use-on-load';

export default function Component() {
  const isXs = useP2GMediaQueryOnly('xs');
  const { track } = useAnalytics();
  const { dispatch } = useContext(ContentContext);
  const { dispatch: navigationDispatch } = useContext(NavigationContext);
  const { setValue: setIsSmartSendUser } = useLocalStorage(LocalStorageKeys.HasVisitedSmartSend, true);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  useOnLoad(() => {
    const title = t('SOLD_ITEMS_PAGE_TITLE', { defaultValue: 'Smart Send' });
    document.title = title;
    dispatch({ type: 'SET_CONTENT_GROUP', contentGroup: ContentGroups.SMARTSEND });
    setIsSmartSendUser(true);
    navigationDispatch({ type: 'INITIALISE_NAVIGATION', payload: { disable: true } });
  });

  const onPageLoad = useCallback(() => {
    track({
      type: 'page_view',
      payload: {
        ...GenerateBaseAnalyticsPayload([]),
        page: RoutingConstants.SmartSendSetup
      }
    });
  }, [track]);

  // <RequireCustomer silent={true} /> Silent Load Customer. This will load the customer and trigger SmartSend importers in the background.
  // <SearchInitialiser /> This will load the search creds and make them available to the rest of the app, used to populate dashboard.
  return (
    <Suspense>
      <RequireCustomer isXs={isXs} silent={true}>
        <Tagged tag="screen-smartsend">
          <SearchInitialiser>
            <SmartSendSetupProcess isXs={isXs} onPageLoad={onPageLoad} />
          </SearchInitialiser>
        </Tagged>
      </RequireCustomer>
    </Suspense>
  );
}

Component.displayName = 'Smart Send: Sold Items';
